import { render, staticRenderFns } from "./LeagueView.vue?vue&type=template&id=68024e17&scoped=true&"
import script from "./LeagueView.vue?vue&type=script&lang=js&"
export * from "./LeagueView.vue?vue&type=script&lang=js&"
import style0 from "./LeagueView.vue?vue&type=style&index=0&id=68024e17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68024e17",
  null
  
)

export default component.exports